var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg36D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.49 55.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: url(#White_Black-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .cls-1, .cls-3, .cls-5, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n        stroke: url(#White_Black-8);\n      }\n\n      .cls-3 {\n        stroke: url(#White_Black-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n        stroke: url(#White_Black-3);\n      }\n\n      .cls-5 {\n        stroke: url(#White_Black-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n        stroke: url(#White_Black);\n      }\n\n      .cls-7 {\n        stroke: url(#White_Black-9);\n      }\n\n      .cls-8 {\n        stroke: url(#White_Black-11);\n      }\n\n      .cls-9 {\n        stroke: url(#White_Black-6);\n      }\n\n      .cls-10 {\n        stroke: url(#White_Black-10);\n      }\n\n      .cls-11 {\n        stroke: url(#White_Black-7);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.95,
    y1: 11.92,
    x2: 54.55,
    y2: 11.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f8f9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b0af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black",
    "data-name": "White, Black",
    x1: 1.69,
    y1: 11.92,
    x2: 54.71,
    y2: 11.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-2",
    "data-name": "White, Black",
    x1: 9.66,
    y1: 9.08,
    x2: 47.33,
    y2: 9.08,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12.04,
    y1: 45.73,
    x2: 19.36,
    y2: 10.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f8f9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b0af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-3",
    "data-name": "White, Black",
    x1: 1.83,
    y1: 30.79,
    x2: 28.55,
    y2: 30.79,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-4",
    "data-name": "White, Black",
    x1: 2.74,
    y1: 38.96,
    x2: 22.52,
    y2: 38.96,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-5",
    "data-name": "White, Black",
    x1: 13.09,
    y1: 28.21,
    x2: 22.52,
    y2: 28.21,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-6",
    "data-name": "White, Black",
    x1: 5.8,
    y1: 18.2,
    x2: 8.85,
    y2: 18.2,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-7",
    "data-name": "White, Black",
    x1: 25.43,
    y1: 33.97,
    x2: 28.55,
    y2: 33.97,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 44.82,
    y1: 42.19,
    x2: 36.38,
    y2: 13.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-8",
    "data-name": "White, Black",
    x1: 28.3,
    y1: 30.79,
    x2: 54.59,
    y2: 30.79,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-9",
    "data-name": "White, Black",
    x1: 46.97,
    y1: 18.43,
    x2: 50.68,
    y2: 18.43,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-10",
    "data-name": "White, Black",
    x1: 34.8,
    y1: 27.86,
    x2: 54.17,
    y2: 27.86,
    xlinkHref: "#White_Black"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black-11",
    "data-name": "White, Black",
    x1: 34.83,
    y1: 37.43,
    x2: 50.14,
    y2: 37.43,
    xlinkHref: "#White_Black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-36D"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.43,4.68C8.49,5.39,1.95,10.54,1.95,10.54l26.47,8.62,24.63-6.21,1.49-2.58c-5.91-4.87-26.12-5.69-26.12-5.69Zm12.47,6.45h0l-12.36,2.75-13.35-3.06h0s-1.23-.28-1.23-.28c0,0,0,0,.02,0l-3.88-.92s6.17-2.13,19.08-2.58c0,0,10.84-.05,17.73,2.78l-6.01,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.18,7.04c-12.91,.45-19.08,2.58-19.08,2.58l3.88,.92c.59-.13,14.81-3.13,29.55,0l-2.64,.59h0l6.01-1.31c-6.89-2.83-17.73-2.78-17.73-2.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.77,34.3c-.48-.41,0-.72,0-.72,1.43-.59,2.24-1.51,2.66-2.13v-13.74L1.95,10.54v7.64l3.97,.97v-1.89l2.57,.86,13.79,3.66v5.74l.04,.79,.08,1.56-.3,.67-8.61-3.66-.13,.03v6.35l8.98,3.2v3.37l.05,4.11-15.81-5.59v-1.74l-3.51-1.72-.18,.05v6.99l25.52,9.11v-14.67c-.89-1.87-2.24-1.7-2.66-2.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "6.59 38.34 22.39 43.93 22.34 39.82 22.34 40.93 10.1 37.2 10.1 35.22 6.16 33.94 3.08 34.87 6.59 36.59 6.59 38.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "22.39 29.86 22.27 27.49 17.71 25.87 13.49 26.87 22.09 30.53 22.39 29.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "5.92 19.15 8.49 18.12 5.92 17.25 5.92 19.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M25.77,33.58s-.48,.3,0,.72c.41,.36,1.77,.19,2.66,2.06v-4.91c-.42,.63-1.23,1.55-2.66,2.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.46,18.21v-7.67l-26.04,7.17V51.02l24.95-9.78,.67-16.08-19.09,6.29,.68-2.98-.28,.09v-6.72l11.61-3.52h0s.36-.11,.36-.11h0s3.23-.96,3.23-.96v2.38l3.91-1.43Zm-4.45,13.24v6.39l-15.06,5.57v-7.05l15.06-4.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "47.32 18.21 50.49 19.65 50.55 19.63 50.55 17.25 47.32 18.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "54.04 25.16 54.05 25.12 49.17 24.22 35.35 28.56 34.96 31.45 54.04 25.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "47.27 32.34 47.27 36.07 34.96 40.13 34.96 43.4 50.01 37.83 50.01 31.45 47.27 32.34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg36D);
export default __webpack_public_path__ + "static/media/36D.ce357818cca4026bec346318f3ca548e.svg";
export { ForwardRef as ReactComponent };